export default function useIsMobile(setIsMobile: Function): () => void {
    function handleResize(): void {
        setIsMobile(window.innerWidth < 768);
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    return (): void => window.removeEventListener('resize', handleResize);
}
